import { requestWithoutToken as request, requestWithToken } from "./api";

export const login = (username, password) =>
    request.post("/login/", { username, password });

export const logout = () => requestWithToken.post("/logout/");

export const register = (data) => request.post("/users/signup/", data);

export const userInfo = (email, company_id = null) => {
    const payload = { email: email };
    if (company_id) {
        payload["company_id"] = company_id;
    }
    return request.post("/users/user_info/", payload);
};

export const activeUser = (email) =>
    request.post("/users/active_user/", { email });

export const deleteUser = () => request.delete("/users/");

export const recoveryEmail = (email) =>
    request.post("/users/password/reset_password/", { email });

export const validateRecoveryToken = (token) =>
    request.post("/users/password/validate_token/", { token });

export const getCompanyFromUUID = (uuid) =>
    request.post("/company/from_uuid/", { uuid });

export const changePassword = (data = {}) =>
    request.post("/users/password/confirm/", data);

export const refresh = (token, config = {}) =>
    request.post("/refresh_token/", { token }, config);

export const verify = (token) => request.post("/verify_token/", { token });

export const validatePromotionalToken = (token) =>
    request.post("/promotional_users/validate_token/", { token });

export const updateUserPassword = (userData) =>
    request.post("/users/change_user_email_pass/", { ...userData });
